(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

  const initCarousel = (root) => {
    if (root.dataset.carouselReady === 'true' || typeof window.EmblaCarousel !== 'function') return
    const viewport = root.querySelector('[data-carousel-viewport]')
    if (!viewport) return

    const embla = window.EmblaCarousel(viewport, {
      align: 'start',
      containScroll: 'trimSnaps',
      duration: reduceMotion ? 0 : 22,
    })
    const prev = root.querySelector('[data-carousel-prev]')
    const next = root.querySelector('[data-carousel-next]')

    const sync = () => {
      if (prev) prev.disabled = !embla.canScrollPrev()
      if (next) next.disabled = !embla.canScrollNext()
    }

    prev?.addEventListener('click', () => embla.scrollPrev())
    next?.addEventListener('click', () => embla.scrollNext())
    embla.on('select', sync)
    embla.on('reInit', sync)
    sync()
    root.dataset.carouselReady = 'true'
  }

  const initAll = (scope) => {
    const root = scope && scope.querySelectorAll ? scope : document
    root.querySelectorAll('[data-carousel]').forEach(initCarousel)
  }

  const start = () => initAll(document)

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start)
  } else {
    start()
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target))
})()
